var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/auth/ResetPassword/steps/ResetPasswordSecondStep.tsx";
import React from 'react';
import { Text, VStack } from '@adc/parallax-component-library';
import { usePartner } from 'Hooks';
import { Button, Main, ResponsiveContainer } from 'Components/utility';
import i18n from 'Utilities/i18n';
const ResetPasswordSecondStep = () => {
  const {
    partner,
    handleResetPasswordDone
  } = usePartner();
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: i18n.t('Global.microcopy.common.libreLogoLight'),
    alt: "",
    id: "Global.microcopy.common.libreLogo",
    style: {
      position: 'absolute',
      zIndex: 1,
      marginTop: '20px',
      width: '100px',
      height: '50px',
      objectFit: 'contain',
      left: '50%',
      transform: 'translateX(-50%)'
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(ResponsiveContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: i18n.t('ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.media.passwordResetSuccess'),
    alt: "",
    id: "ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.media.passwordResetSuccess",
    style: {
      marginTop: '40px',
      height: '105px',
      objectFit: 'contain'
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(VStack, {
    marginTop: "$7",
    gridRowGap: "$2",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.primaryText",
    fontWeight: '$h2.strong',
    fontSize: "$h2.strong",
    color: "$text.100",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 11
    }
  }, i18n.t('ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.primaryText')), /*#__PURE__*/React.createElement(Text, {
    testID: "ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.secondaryText",
    fontWeight: "$bodyBase.default",
    fontSize: "$bodyBase.default",
    color: "$text.100",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 11
    }
  }, i18n.t('ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.secondaryText'))), /*#__PURE__*/React.createElement(VStack, {
    width: "90%",
    marginHorizontal: "auto",
    marginTop: "$12",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onPress: handleResetPasswordDone,
    testID: "ResetPasswordSuccessful.backToPartner",
    label: i18n.t('ResetPasswordSuccessful.microcopy.ButtonTextSet.backToPartner', {
      partnerName: partner.displayName
    }),
    "aria-label": i18n.t('ResetPasswordSuccessful.microcopy.ButtonTextSet.backToPartner', {
      partnerName: partner.displayName
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 11
    }
  }))));
};
export default ResetPasswordSecondStep;